<template>
  <div class="stats-banner">
    <div class="highlighted">
      <UiComponentHeading
        as="paragraph"
        :level="2"
      >
        <slot name="percent" />
      </UiComponentHeading>
      <UiComponentParagraph><slot name="percentText" /></UiComponentParagraph>
    </div>
    <div class="content">
      <UiComponentParagraph><slot name="paragraph" /></UiComponentParagraph>
      <UiComponentParagraph
        size="s"
        class="small-text"
      >
        <slot name="infos" />
      </UiComponentParagraph>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.stats-banner {
  @apply flex flex-col w-full p-4 border border-grey-blue-200 rounded-4xl;

  @screen md {
    @apply p-6;
  }

  @screen xl {
    @apply flex-row items-center pr-20;
  }

  .highlighted {
    @apply flex flex-col gap-4 w-full p-6 bg-livestorm-blue-500 rounded;

    @screen md {
      @apply flex-row items-center;
    }

    @screen xl {
      @apply flex-col items-start gap-2 max-w-[415px];
    }

    .h2,
    p {
      @apply font-inter text-white;
    }

    .h2 {
      @apply font-semibold text-5xl leading-14;

      & + p {
        @apply font-normal text-xl leading-8;
      }
    }
  }

  .content {
    @apply flex flex-col gap-2 mt-4 px-2;

    @screen md {
      @apply mt-6;
    }

    @screen xl {
      @apply ml-20 mt-0;
    }

    p {
      @apply text-grey-blue-600;
    }
  }
}
</style>
